export enum StepName {
  TOP_UP = 1,
  SEND = 2,
  REFUND = 3,
}

export enum StepStatus {
  PENDING,
  FAILED,
  SUCCESS,
}

export type SendingState = {
  name: StepName
  status: StepStatus
}
